<div class="tabs" role="navigation">
  <ul class="nav nav-pills">
    @for (tab of tabs; track i; let i = $index) {
    <li class="nav-item">
      <button class="btn btn-light" role="tab" routerLinkActive="active" [routerLink]="tab.routerLink">
        {{tab.name}}
      </button>
    </li>
    }
  </ul>
</div>
